import { useMutation, useQuery } from '@tanstack/react-query';
import { request } from 'utils/request';

export const getLBotTele = (params, headers) => request.get('/api/v1/telegrams', { params, ...headers });
export const createBotTele = data => request.post('/api/v1/telegrams', data);
export const createWebhook = data => request.post('/api/v1/telegram/register', data);
export const updateBotTele = data => request.post('/api/v1/telegrams/update', data);
export const deleteBotTele = data => request.post('/api/v1/telegrams/delete', data);
export const deleteWebhook = data => request.post('/api/v1/telegram/delete', data);
export const updateBotTeleStatus = data => request.post('/api/v1/socials/update-status', data);
// Mutation
export const useCreateBotTeleMutation = () => useMutation({ mutationFn: createBotTele });
export const useCreateWebhookMutation = () => useMutation({ mutationFn: createWebhook });
export const useUpdateBotTeleMutation = () => useMutation({ mutationFn: updateBotTele });
export const useGetBotTeleListMutation = () => useMutation({ mutationFn: getLBotTele });
export const useDelBotTeleListMutation = () => useMutation({ mutationFn: deleteBotTele });
export const useDelWebhooktMutation = () => useMutation({ mutationFn: deleteWebhook });
export const useUpdateBotTeleStatusMutation = () => useMutation({ mutationFn: updateBotTeleStatus });
// Query
export const useQueryGetBotTeleList = (params, options = {}) =>
    useQuery({ queryKey: ['getBotTeleList', params], queryFn: () => getLBotTele(params), ...options });